export type LinkPreviewField = {
  placeholder: string
  icon: string
} & (
  | { field: 'domain'; style: 'domainStyle' }
  | { field: 'title'; style: 'titleStyle' }
  | { field: 'description'; style: 'descriptionStyle' }
)

export const defaultFields: LinkPreviewField[] = [
  {
    field: 'domain',
    style: 'domainStyle',
    placeholder: 'Click here to add a domain',
    icon: '',
  },
  {
    field: 'title',
    style: 'titleStyle',
    placeholder: 'Click here to add a title',
    icon: '',
  },
  {
    field: 'description',
    style: 'descriptionStyle',
    placeholder: 'Click here to add a description',
    icon: '',
  },
]

export const twitterTweetMobileFields: LinkPreviewField[] = [
  {
    field: 'title',
    style: 'titleStyle',
    placeholder: 'Add headline...',
    icon: '',
  },
  {
    field: 'domain',
    style: 'domainStyle',
    placeholder: 'Add website URL...',
    icon: '',
  },
]

export const twitterTweetDesktopFields: LinkPreviewField[] = [
  {
    field: 'title',
    style: 'titleStyle',
    placeholder: 'Add headline...',
    icon: '',
  },
  {
    field: 'description',
    style: 'descriptionStyle',
    placeholder: 'Add description...',
    icon: '',
  },
  {
    field: 'domain',
    style: 'domainStyle',
    placeholder: 'Add website URL...',
    icon: 'twitter-desktop-website-card-url',
  },
]

export const threadsStandardMobileFields: LinkPreviewField[] = [
  {
    field: 'domain',
    style: 'domainStyle',
    placeholder: 'Add website URL...',
    icon: '',
  },
  {
    field: 'title',
    style: 'titleStyle',
    placeholder: 'Add headline...',
    icon: '',
  },
]

export const threadsStandardDesktopFields: LinkPreviewField[] = [
  {
    field: 'domain',
    style: 'domainStyle',
    placeholder: 'Add website URL...',
    icon: '',
  },
  {
    field: 'title',
    style: 'titleStyle',
    placeholder: 'Add headline...',
    icon: '',
  },
]
